import { Room } from '@mui/icons-material'
import { Autocomplete, Box, TextField, Typography, styled } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { setGlobalCountry } from '../../../../redux/actions/global'
import { IRootState } from '../../../../redux/types'
import ReportButton from '../buttons/ReportButton'
import ResetButton from '../buttons/ResetButton'

export const BreadcumbContainer = styled(Box)(({ theme }) => ({
  padding: 5,
  borderBottom: `1px solid ${theme.palette.grey[100]}`,
  '&  > svg': {
    position: 'relative',
    top: '5px',
    right: '4px'
  },
  '& > p': {
    padding: '5px'
  }
}))

interface ICountry {
  id: number
  code: string
  name: string
}

function ClientBreadcumb() {
  const { pathname, search } = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const searchParams = new URLSearchParams(search)

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { globalCountryId } = useSelector((state: IRootState) => state.global)

  useEffect(() => {
    if (authUser !== null) {
      if (search && searchParams.get('globalCountryId') !== null && globalCountryId !== Number(searchParams.get('globalCountryId'))) {
        if (authUser.countries_name.find((country: any) => country.id === Number(searchParams.get('globalCountryId'))) != undefined)
          handleGlobalCountry(Number(searchParams.get('globalCountryId')))
        else {
          searchParams.set('globalCountryId', authUser.countries[0])
          navigate(`${pathname}?${searchParams}`, { replace: true })
          handleGlobalCountry(authUser.countries[0])
        }
      }
    }
  }, [])

  const handleGlobalCountry = (countryId: number | undefined) => {
    if (!countryId) return

    dispatch(setGlobalCountry(countryId))
    localStorage.setItem('globalCountryId', countryId.toString())
    searchParams.set('globalCountryId', countryId.toString())
    navigate(`${pathname}?${searchParams}`, { replace: true })
  }

  return (
    <>
      <Box>
        {authUser !== null && (
          <BreadcumbContainer display="flex" justifyContent="space-between" alignContent="center">
            <Box display="flex" alignItems="center">
              <ResetButton />
              <ReportButton />
            </Box>

            {/* <Box display="flex" alignItems="center">
                            <Breadcrumbs />
                        </Box> */}

            <Box display="flex" alignItems="center">
              <Room color="primary" fontSize="small" />
              {authUser?.countries_name !== undefined &&
                globalCountryId !== null &&
                (authUser.countries.length === 1 ? (
                  <Typography color="primary" variant="body2" style={{ display: 'flex' }}>
                    {authUser.countries_name.find((country: any) => country.id === globalCountryId)?.name}
                  </Typography>
                ) : (
                  <>
                    <Autocomplete
                      sx={theme => ({
                        '& .MuiInputBase-root': {
                          border: 'none',
                          padding: '0px',
                          color: theme.palette.primary.main
                        },
                        '&.admin .MuiInputBase-root': {
                          width: '179px',
                          paddingRight: '0px'
                        },
                        '&.client .MuiInputBase-root': {
                          width: 'auto',
                          minWidth: 170,
                          paddingRight: '28px'
                        },
                        '& .MuiAutocomplete-clearIndicator': {
                          marginRight: '-10px'
                        },
                        '& .MuiAutocomplete-endAdornment svg': {
                          color: theme.palette.primary.main
                        },
                        '& .MuiFormControl-root': {
                          marginBottom: '0px'
                        }
                      })}
                      id="countries-menu"
                      disableClearable
                      options={authUser.countries_name}
                      value={authUser.countries_name.find((country: any) => country.id === globalCountryId)}
                      autoComplete
                      getOptionLabel={(country: ICountry) => (country.id !== undefined ? country.name : '')}
                      renderTags={() => authUser.countries_name.find((country: any) => country.id === globalCountryId).name}
                      renderInput={params => <TextField {...params} />}
                      onChange={(_, newValue) => handleGlobalCountry(newValue?.id)}
                      className={'client'}
                    />
                  </>
                ))}
            </Box>
          </BreadcumbContainer>
        )}
      </Box>
    </>
  )
}

export default ClientBreadcumb
